import React from 'react';
import student1 from "../assets/images/image1.png"; // Replace with actual images
import student2 from "../assets/images/image2.png";


export default function EarnAndLearn() {
    return (
        <div className="min-h-screen bg-gray-100 p-6 text-gray-800">
            <h2 className="text-3xl font-bold text-center mb-8">
                Karmaveer Bhaurao Patil Earn & Learn Scheme
            </h2>

            <div className="max-w-5xl mx-auto space-y-8">

                {/* Objectives */}
                <section className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-xl font-semibold mb-4">A. Objectives of the Scheme:</h3>
                    <ul className="list-disc list-inside space-y-1">
                        <li>To provide financial assistance to the financially backward and needy students.</li>
                        <li>To make students a knowledge servant.</li>
                        <li>To motivate students for self-employment.</li>
                        <li>To make students aware about work culture.</li>
                    </ul>
                </section>

                {/* Implementation */}
                <section className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-xl font-semibold mb-4">B. Implementation in Arya Senior College, Manjari:</h3>
                    <p>
                        The scheme has been successfully implemented in Arya Senior College, Manjari, Tal Rahuri, Dist. Ahmednagar, Pin 413705. Many students from Arts, Commerce & Science departments were benefitted through the financial assistance provided by our institute in association with Savitribai Phule Pune University, in the form of Earn and Learn scheme.
                    </p>
                </section>

                {/* Financial Details Table */}
                <section className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-xl font-semibold mb-4">C. Details of Financial Assistance Provided:</h3>
                    <div className="overflow-x-auto">
                        <table className="min-w-full table-auto border border-gray-300 text-sm">
                            <thead className="bg-gray-200">
                                <tr>
                                    <th className="border px-4 py-2">Sr. No.</th>
                                    <th className="border px-4 py-2">Academic Year</th>
                                    <th className="border px-4 py-2">No. of Students Benefitted</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="hover:bg-gray-50">
                                    <td className="border px-4 py-2">1</td>
                                    <td className="border px-4 py-2">2024-25</td>
                                    <td className="border px-4 py-2">6</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>

                {/* Coordinator Info */}
                <section className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-xl font-semibold mb-4">D. Institute Coordinator:</h3>
                    <p>
                        Assistant Professor & Student Welfare Officer
                    </p>
                </section>

                {/* Photo Gallery */}
                <section className="bg-white p-6 rounded-xl shadow">
                    <h3 className="text-xl font-semibold mb-6">E. Photo Gallery: Students Working in Various Departments</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        <img src={student1} alt="Student 1" className="rounded-lg shadow" />
                        <img src={student2} alt="Student 2" className="rounded-lg shadow" />
                       
                    </div>
                </section>
            </div>
        </div>
    );
}
